module.exports = __webpack_public_path__ + "static/img/box_bg.2e6e27f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/box_bg.svg
// module id = qYPi
// module chunks = 0